import * as fromReducer from './device-location.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceLocation, DeviceLocationState } from './device-location.state';
import { DevicesRouterStoreSelectors } from '../../../../stores/router';

export const selectDeviceLocationState = createFeatureSelector<DeviceLocationState>(
  fromReducer.MdmDeviceLocationFeatureKey
);

export const selectDeviceLocation = createSelector(selectDeviceLocationState, fromReducer.selectDeviceLocation);

export const selectDeviceLocationEntities = createSelector(
  selectDeviceLocationState,
  fromReducer.selectDeviceLocationEntities
);

export const selectDeviceLocationIds = createSelector(selectDeviceLocationState, fromReducer.selectDeviceLocationIds);

export const selectDeviceLocationByUdid = createSelector(
  selectDeviceLocation,
  DevicesRouterStoreSelectors.selectUdid,
  (location: DeviceLocation[], udid: string) => location.find((l) => l.udid === udid)
);
